import React from 'react';
import { Phone } from 'lucide-react';
import { companyInfo } from '../mock/mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Company Info */}
          <div className="text-center md:text-left">
            <div className="mb-4">
              <img 
                src="/zeno-logo-cropped.png" 
                alt="Zeno Pharma" 
                className="h-20 w-auto mx-auto md:mx-0"
              />
            </div>
            <p className="text-gray-400 max-w-md">
              Nutrition-led wellness with a focused portfolio of nutraceuticals and nutritional supplements.
            </p>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-end gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                <Phone className="text-white" size={20} />
              </div>
              <div className="text-left">
                <div className="text-sm text-gray-400">Customer Support</div>
                <div className="font-semibold text-lg">{companyInfo.phone}</div>
              </div>
            </div>
            <a 
              href={`mailto:${companyInfo.email}`}
              className="text-gray-400 hover:text-red-500 transition-colors duration-200"
            >
              {companyInfo.email}
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <div className="text-gray-400 text-sm">
            © 2026 Zeno Pharma. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;